import { IPaginatedTransactionHistory } from "../../interfaces/transaction";
import { IFetchTransactionHistoryAction } from "../actions/transactionHistory.action";
import { ActionType } from "../action_types";


export const fetchPaginatedTransactionHistory = (paginatedTransactionHistory: IPaginatedTransactionHistory): IFetchTransactionHistoryAction => {
  return {
    type: ActionType.FETCH_TRANSACTION_HISTORY,
    payload: { paginatedTransactionHistory },
  };
};
